const passwordResetParams = [
    "p=B2C_1_password_reset_ng",
    "nonce=defaultNonce",
    "scope=openid",
    "response_type=id_token",
    "prompt=login"
];

const uverifi = {
    local: {
        api: {
            url: "https://api-man-staging.uverifi.com/client-api"
        },
        auth: {
            url: "https://auth-staging.uverifi.com"
        },
        clientId: "44738c8b-2873-4e2b-bad8-a16b5a0a7a2a",
        allowedDistanceRange: 0.4,
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://portal-staging.uverifi.com",
            url: "https://uverifiadb2cstaging.b2clogin.com/uverifiadb2cstaging.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "4e70f62e-20a1-4846-8ceb-125f0d2d1926",
                datasetId: "4a5c1fbc-3d87-44a5-baf7-2f348f83c2f7"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "184c018e-f27e-4564-9fcd-780cf70d6526",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "d98fd43e-1baa-4909-877c-e3c395f92413",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "ce8aad97-6f42-489c-ad8f-ec8be666cbd3",
                    datasetId: "5b98f105-9a07-43fa-b731-65a902eb33e3"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "72a34df9-1144-43ea-8bfc-8754070cf27f",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "e8c15d8a-08f4-4a54-92a7-4eeac07e2eeb",
                    datasetId: "325fe4c3-af07-4e09-b09d-e1ca56c001a3"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "e3142bbf-279e-4be5-97d6-9a1d357e425c",
                    datasetId: "9d16cfde-bd6b-47fc-ae4f-d5b9f82099c8"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "4ff87a68-4383-4ca1-9d83-6052bdb76c4e",
                    datasetId: "aaa6b5b5-64f7-4048-9cb2-af1f1e32e05f"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "62792a67-5515-4b52-80ea-dc06df6467e8",
                    datasetId: "9629cea4-dbe8-4617-9e5d-4d7cf4c2d9db"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "72fdde48-c2cd-4552-a889-5731a2b572a6",
                    datasetId: "730c5139-ac21-4207-ae78-b3d12e710434"
                }
            ]
        },
        supportEmail: "uverifisupport@onedatascan.com"
    },
    staging: {
        api: {
            url: "https://api-man-staging.uverifi.com/client-api"
        },
        auth: {
            url: "https://auth-staging.uverifi.com"
        },
        clientId: "44738c8b-2873-4e2b-bad8-a16b5a0a7a2a",
        allowedDistanceRange: 0.4,
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://portal-staging.uverifi.com",
            url: "https://uverifiadb2cstaging.b2clogin.com/uverifiadb2cstaging.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "4e70f62e-20a1-4846-8ceb-125f0d2d1926",
                datasetId: "4a5c1fbc-3d87-44a5-baf7-2f348f83c2f7"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "bd028fa9-80dd-4e47-8975-7ba8c489e940",
                    datasetId: "730c5139-ac21-4207-ae78-b3d12e710434"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "b6992d09-86c5-4545-8d55-b49fff46c48c",
                    datasetId: "730c5139-ac21-4207-ae78-b3d12e710434"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "496df80f-3b51-4bf2-acce-14bc402faf4a",
                    datasetId: "9440a97d-ef2f-48d4-ba9b-76da395b15fb"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "b68385b8-31ce-49d2-9327-8b5d4ad3f936",
                    datasetId: "2cd8a77b-bf0c-4158-8de0-69d83983b6fa"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "7839570f-c80a-44de-8ee0-4e360a67ddd5",
                    datasetId: "166bc22f-5f97-4549-9fe6-94a24c991753"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "99c8696e-156f-44a2-988d-f045939f1781",
                    datasetId: "1c2697d5-03e9-4782-b295-b6d946ff6481"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "4ff87a68-4383-4ca1-9d83-6052bdb76c4e",
                    datasetId: "aaa6b5b5-64f7-4048-9cb2-af1f1e32e05f"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "62792a67-5515-4b52-80ea-dc06df6467e8",
                    datasetId: "9629cea4-dbe8-4617-9e5d-4d7cf4c2d9db"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "72fdde48-c2cd-4552-a889-5731a2b572a6",
                    datasetId: "730c5139-ac21-4207-ae78-b3d12e710434"
                }
            ]
        },
        supportEmail: "uverifisupport@onedatascan.com"
    },
    prod: {
        api: {
            url: "https://api-man.uverifi.com/client-api"
        },
        auth: {
            url: "https://auth.uverifi.com"
        },
        clientId: "9e1e1c45-4b2b-48b4-8454-3dd508bd7407",
        allowedDistanceRange: 0.4,
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://portal.uverifi.com",
            url: "https://uverifiadb2c.b2clogin.com/uverifiadb2c.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "eac5d07e-897e-4b64-8b04-24bf636e8e59",
                datasetId: "d0ff093f-5517-4c4a-9a0e-2e37e8ae7a98"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "626c45aa-1381-43a5-a36e-dfd23aaade8b",
                    datasetId: "a2436e85-e285-48e3-a2a7-56e65efc5ba0"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "7c5161d8-3734-4ae7-a9bb-d664ef2a52e3",
                    datasetId: "a2436e85-e285-48e3-a2a7-56e65efc5ba0"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "379ea8b5-4d5e-49c5-827c-a42e8f482ca0",
                    datasetId: "7c6d04dd-fafb-4368-866b-b7ef187bd083"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "a71de1c9-7466-49c0-89cf-4b33a63a76d5",
                    datasetId: "6563320c-96fb-4e60-a342-f29d7efc05ce"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "112d1b74-e592-4467-88a9-8ed46d2916ef",
                    datasetId: "d3bfa560-a7ba-4648-ae30-d89255f14e3f"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "ddbbcafb-e63b-414c-88c3-4e09910eea7d",
                    datasetId: "5be80696-7ddc-4dab-9e08-58015c3f0aa8"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "02265b9b-2bea-467c-8332-008f26ed4c10",
                    datasetId: "10110728-e748-4b5b-954a-978637972f53"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "ffcdd596-22d5-4118-99c4-59d1076a9637",
                    datasetId: "0c1dac59-aba7-4b5f-9e0c-4982ba0ac8af"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "64bf4f8e-15b5-4e1f-b511-b9b9204a7dda",
                    datasetId: "a2436e85-e285-48e3-a2a7-56e65efc5ba0"
                }
            ]
        },
        supportEmail: "uverifisupport@onedatascan.com"
    }
};

export default uverifi;
